<template>
  <a-modal
    class="company-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    title="关联推广员"
    @ok="$emit('onCancel')"
    @cancel="$emit('onCancel')"
  >
    <a-table

      :columns="columns1"
      :data-source="data"
      size="middle"
      :row-key="record => record.promoter_id"
      :pagination="false"
    >
      <a-table
        slot="expandedRowRender"
        slot-scope="record"
        :columns="columns2"
        :data-source="data.length>0?record.drug_list:[]"
        size="middle"
        :row-key="record => record.id"
        :pagination="false"
      />
    </a-table>
  </a-modal>
</template>
<script>
export default {
  props: ['data', 'visible'],
  data() {
    return {
      columns1: [
        {
          title: '编号',
          dataIndex: 'promoter_id',
        },
        {
          title: '推广员名称',
          dataIndex: 'user_realname',
        },
      ],
      columns2: [
        {
          title: '企业名称',
          dataIndex: 'company_name',
        },
        {
          title: '大区名称',
          dataIndex: 'area_name',
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>

</style>